import { INITIAL_TABLE_PAGE, TABLE_PAGE_SIZE } from "../constants/visits-geo-breakdown";
import type { AccountOverviewCompanyState } from "../types/state";

const initialAccountOverviewCompanyState: AccountOverviewCompanyState = {
    // Top level domains
    areAllTLDSitesIncluded: false,
    // GEO breakdown card
    geoBreakdownTablePage: INITIAL_TABLE_PAGE,
    geoBreakdownTablePageSize: TABLE_PAGE_SIZE,
    geoBreakdownTableData: {
        totalCount: 0,
        data: [],
    },
    isGEOBreakdownTableDataBeingFetched: false,
    // Monthly visits overtime card
    visitsOverTimeEntriesPerWebSource: {},
    selectedTimeGranularity: "Monthly",
    isMonthToDateActive: false,
    // Signals
    signalEvents: [],
    selectedEventFilter: "All",
    isSignalEventsBeingFetched: undefined,
    isSignalEventsFetched: false,
    filteredSignalEvents: [],
    otherSignalEvents: [],
    isOtherSignalEventsBeingFetched: false,

    // Company structure
    isCompanySelectionEnabled: false,
    selectedCompanyDomains: new Set(),
};

export default initialAccountOverviewCompanyState;
